import { BaseReducer } from 'redux-di-container';

import { axiosApi, handleAxiosResponse } from '../util/axiosApi';

export default class MailingService extends BaseReducer {
  getInitialState() {
    return {
      inProgress: false,
      error: null,
    };
  }

  $mailingState(state) {
    return this.select(state);
  }

  mailingRequestAction() {
    return state => {
      state.inProgress = true;
      state.error = null;
    };
  }

  mailingRequestSuccessAction() {
    return state => {
      state.inProgress = false;
    };
  }

  mailingRequestErrorAction(error) {
    return state => {
      state.inProgress = false;
      state.error = error.message;
    };
  }

  sendMail(data) {
    this.mailingRequestAction();
    return axiosApi.post('/mailing/send', {
      f_n: data.firstName,
      l_n: data.lastName,
      e: data.email,
      m: data.message,
    }, {
      withCredentials: true,
    })
      .then(handleAxiosResponse)
      .then(response => {
        this.mailingRequestSuccessAction();
        return response;
      })
      .catch(error => {
        this.mailingRequestErrorAction(error);
        throw error;
      })
    ;
  }

  sendMailProfileComplete(data) {
    // this.mailingRequestAction();
    return axiosApi.post('/mailing/send-completing-profile', {
      e: data.email,
    }, {
      withCredentials: true,
    })
      .then(handleAxiosResponse)
      .then(response => {
        // this.mailingRequestSuccessAction();
        return response;
      })
      .catch(error => {
        // this.mailingRequestErrorAction(error);
        throw error;
      })
    ;
  }
}
